import { render, staticRenderFns } from "./RegistrationRow.vue?vue&type=template&id=4a3416aa&scoped=true"
import script from "./RegistrationRow.vue?vue&type=script&lang=js"
export * from "./RegistrationRow.vue?vue&type=script&lang=js"
import style0 from "./RegistrationRow.vue?vue&type=style&index=0&id=4a3416aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3416aa",
  null
  
)

export default component.exports